var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundGradientMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 282,
    viewBox: "0 0 320 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_466_1173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.362 167.726C366.176 84.9108 158.445 48.069 44.9774 40C133.386 53.3799 294.126 96.3542 229.817 161.212C165.507 226.069 -96.8566 238 -220 235.858C-82.2183 247.653 212.548 250.54 289.362 167.726Z",
    fill: "#F68500",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_466_1173",
    x: -260,
    y: 0,
    width: 606,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_466_1173"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradientMobile);
export default __webpack_public_path__ + "static/media/background-gradient-mobile.d633dd04bce328b4ad8743e9e8667ef2.svg";
export { ForwardRef as ReactComponent };